mainApp.component('failoverConfiguration', {
    templateUrl: '/public/components/configuration/failover/failover-configuration.component.html',
    bindings: {
        config: "<",
        changesListener: "&?",
        precedencesList: "<?",
        isActiveActive: "<?",
        isActivePassive: "<?",
    },
    controller: function($scope, $controller, FailoverConfigurationService) {
        const ctrl = this;

        let originalConfig = {};
        ctrl.defaults = {};

        ctrl.ready = false;

        ctrl.precedencesList = {
             1: '1 (Primary)',
             2: '2 (Secondary)',
             3: '3 (Secondary)',
        };

        ctrl.isActiveActive = true;
        ctrl.isActivePassive = true;

        //Re-init current component when config changed.
        ctrl.$onChanges = function(changes) {
            ctrl.ready = false;
            if(!isEmpty(changes.config)) {
                if(ctrl.config) {
                   originalConfig = angular.copy(ctrl.config);
                   fixActivePassiveFailoverEnabled();
                   if(ctrl.config.accountId) {
                       ctrl.defaultLabel = "Account default ";
                       FailoverConfigurationService.getDefault(ctrl.config.accountId, defaultOnSuccess);
                   } else {
                       ctrl.defaultLabel = "System default ";
                       FailoverConfigurationService.getSystemDefault(defaultOnSuccess);
                   }
                }
            }
        };

        ctrl.onConfigChanged = function (current, previous, path) {
          if(_.isEmpty(current)) {
            _.set(ctrl.config, path, {});
          } else {
            _.set(ctrl.config, path, angular.copy(current));
          }
          if(ctrl.changesListener) {
            ctrl.changesListener({current: ctrl.config, previous: originalConfig});
          }
        };

        ctrl.configChange = function () {
            if(ctrl.changesListener) {
                ctrl.changesListener({current: ctrl.config, previous: originalConfig});
            }
        }

        function defaultOnSuccess(data) {
          if(data == null) {
            throw "Default can't be null";
          }
          ctrl.defaults = data;
          if(typeof (ctrl.precedencesList[ctrl.defaults.activePassiveFailoverConfiguration.acceptableNaturalOrder]) == 'undefined') {
            //precedencesList may have only 2 options [1: Primary, 2: Secondary]
            //if get inside this if it means that there was 2 configured at account level, but 2 is not a valid option for current Site, so we change default to be 1 at site level.
            ctrl.defaults.activePassiveFailoverConfiguration.acceptableNaturalOrder = 1;
          }
          fixActivePassiveFailoverEnabled();
          ctrl.ready = true;
        };

        function fixActivePassiveFailoverEnabled() {
            if( typeof(ctrl?.config?.activePassiveFailoverConfiguration?.activePassiveFailoverEnabled) == 'undefined') {
                if(! (typeof ctrl?.defaults?.activePassiveFailoverConfiguration == 'undefined')) {
                    ctrl.config.activePassiveFailoverConfiguration.activePassiveFailoverEnabled = ctrl.defaults.activePassiveFailoverConfiguration.activePassiveFailoverEnabled;
                    originalConfig.activePassiveFailoverConfiguration.activePassiveFailoverEnabled = ctrl.defaults.activePassiveFailoverConfiguration.activePassiveFailoverEnabled;
                }
            }
        }


        //Check if all object fields are null / undefined / {}
        function isEmpty(obj) {
          for (let key in obj) {
              let field = obj[key];
              if (field !== null && typeof field !== "undefined" && (field !== Object(field) || Object.values(field).length >= 1 ))
                  return false;
          }
          return true;
        };

    }
});
